import styled from "styled-components"

export const TagsWrapper = styled.div`
  margin: 1rem;
  h3{
    margin: 0;
    padding: 0;
    font-size: ${({ theme }) => theme.fontSizes.md};
  }
  .tags_container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    li.tag {
      list-style: none;
      margin: 0;
      margin-right: 5px;
      cursor: pointer;
      & a {
        margin: 0;
        padding: 5px 8px;
        font-size: 12px;
        background-color: #777d71;
        color: #fff;
        text-decoration: none;
      }
    }
  }
`
